import { cn } from '@talentmesh/ui/lib/utils';
import { Circle } from 'lucide-react';

import UIStrings from '@/Utils/UIStrings';

interface CandidateTestMonitoringFeatureProps {
    label: string;
    isEnabled: boolean;
}

function CandidateTestMonitoringFeature({ label, isEnabled }: CandidateTestMonitoringFeatureProps) {
    const getText = (value: boolean): string => {
        if (value) {
            return UIStrings.Enabled;
        }
        return UIStrings.Disabled;
    };

    return (
        <div className="flex flex-row items-center justify-center gap-2">
            <p className="text-sm">{`${label}:`}</p>
            <Circle
                className={cn('size-3 shrink-0 fill-current', isEnabled ? 'text-green-600' : 'text-destructive')}
                aria-hidden
            />
            <p className={cn('text-sm', isEnabled ? 'text-green-600' : 'text-destructive')}>{getText(isEnabled)}</p>
        </div>
    );
}

export default CandidateTestMonitoringFeature;
